import React from 'react';

import { FaOptionIcon, openIcon } from '@europrocurement/l2d-icons';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';

export type LinkToColumnProps = {
    tooltip?: string;
    link: string;
};

const LinkToColumn: React.FunctionComponent<LinkToColumnProps> = function ({ tooltip, link }) {
    return (
        <Box
            onClick={(e) => e.stopPropagation()}
            component={Link}
            to={link}
            sx={{
                marginLeft: '0.5em',
                display: 'inline-flex',
                alignItems: 'center',
                color: 'primary.main',
                textDecoration: 'none',
                fontSize: '0.7em',
            }}
        >
            <FaOptionIcon
                icon={openIcon.props.icon}
                tooltip={tooltip ?? 'Ouvrir'}
            />
        </Box>
    );
};

export default LinkToColumn;
